import { createApiRef } from '@backstage/core-plugin-api';
import { AppExtensionManifest } from '../types';

export const appExtensionsApiRef = createApiRef<AppExtensionsApi>({
  id: 'plugin.app-extensions.service',
});

export interface AppExtensionsApi {
  listAppExtensions(): Promise<AppExtensionManifest[]>;
  getAppExtension(
    extensionId: string,
  ): Promise<AppExtensionManifest | undefined>;
}
